import { httpRequest } from "../../../utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { IReportBillSearch, IReportBillDetail } from "./reportBillType"

class ReportBillService {
    async page(searchVo: IReportBillSearch) {
        const apiUrl = "/zzw-vrm/repairReport/list";
        return await httpRequest.post<IPage<IReportBillDetail>>(apiUrl, searchVo);
    }
    //导出
    async export(params: object) {
        const apiUrl = "/zzw-vrm/repairReport/export";
        return await httpRequest.postFile(apiUrl, params);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/repairReport/one/${id}`;
        return await httpRequest.get<any>(apiUrl);
    }
    async submitApprovalStatus(val: any) {
        const apiUrl = `/zzw-vrm/repairReport/approval`;
        return await httpRequest.post<any>(apiUrl, val);
    }
    async toCheak(id: string) {
        const apiUrl = `/zzw-vrm/repairReport/check/${id}`;
        return await httpRequest.get<any>(apiUrl);
    }
    async addAdditionalItems(val: any) {
        const apiUrl = `/zzw-vrm/repairReport/additional`;
        return await httpRequest.post<any>(apiUrl, val);
    }
    async customerQueryInfo(val: any) {
        const apiUrl = `/zzw-vrm/base/vehicle/findPage`;
        return await httpRequest.post<any>(apiUrl, val);
    }
    //报修提交
    async quickBillingInsert(params: any) {
        const apiUrl = `/zzw-vrm/repairReport/insert`;
        return await httpRequest.post<any>(apiUrl, params);
    }
}
export const reportBillService = new ReportBillService();
